import React from 'react'

const Footer: React.FC = () => (
  <div className='md:flex justify-center pt-1 md:text-sm text-[10px] text-slate-800'>
    Tecnología de
    <a
      href='https://pinflag.cl'
      target='_blank'
      style={{ textDecoration: 'none' }}
      rel='noreferrer'
    >
      <span className='font-bold'>&nbsp;Pinflag</span>
    </a>
  </div>
)

export default Footer
